'use client';

import styles from './calendarSection.module.css';
import Calendar from '../calendar/calendar';
import { EventItem } from '@/app/interfaces/event';
import { useTranslations } from 'next-intl';

type CalendarSectionProps = {
  events: EventItem[];
};

export default function CalendarSection({ events }: CalendarSectionProps) {
  const t = useTranslations('EventPage');

  return (
    <section className={styles.calendarSection}>
      <h3 className={styles.calenderTitle}>{t('calendar')}</h3>
      <div className={styles.calendarPlaceholder}>
        <Calendar events={events} />
      </div>
    </section>
  );
}
